// @flow
import * as React from 'react';
import useLatest from './useLatest';

const useEventListener = (
    element: HTMLElement | Document,
    type: string,
    listener: () => void
) => {
    const listenerRef = useLatest(listener);

    React.useEffect(() => {
        const handleEvent = e => {
            listenerRef.current(e);
        };

        element.addEventListener(type, handleEvent);

        return () => {
            element.removeEventListener(type, handleEvent);
        };
    }, [element, type, listenerRef]);
};

export default useEventListener;
